import {
    FETCH_SOS,
    FETCH_SOS_SUCCESS,
    FETCH_SOS_FAILED,
    EDIT_SOS
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import { get, push, set } from "firebase/database";
  import { sendSOSNotification } from '../utils/discordNotifications';
  import store from '../store/store';

  // fromTs (epoch ms) is opt-in. Web admin code passes a 30-day floor to
  // bound the cost of large /sos collections. Callers that want all-time
  // (e.g. a future "history" view) pass undefined and get the bare ref.
  // Default = undefined keeps existing call sites' behavior unchanged.
  export const fetchSos = (fromTs) => async (dispatch) => {

    const {
        sosByDateRef
    } = firebase;

    dispatch({
      type: FETCH_SOS,
      payload: null
    });
    try {
      const snapshot = await get(sosByDateRef(fromTs));
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i
          return data[i]
        });
        dispatch({
          type: FETCH_SOS_SUCCESS,
          payload: arr.reverse()
        });
      } else {
        dispatch({
          type: FETCH_SOS_FAILED,
          payload: "No SOS available."
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_SOS_FAILED,
        payload: error.message
      });
    }
  };


  export const editSos = (reasons, method) => async (dispatch) => {

    const {
        sosRef,
        editSosRef
    } = firebase;
  
    dispatch({
      type: EDIT_SOS,
      payload: {method, reasons}
    });
    
    if (method === 'Add') {
      push(sosRef, reasons);
      
      // Send Discord notification for new SOS
      try {
        const settings = store.getState()?.settingsdata?.settings || {};
        await sendSOSNotification(reasons, settings);
      } catch (error) {
        console.error('Failed to send Discord SOS notification:', error);
      }
    }
    else if(method === 'Update'){
      // Include all fields from the reasons object including processedBy and comments
      const updateData = {
        ...reasons,
        processed: reasons.processed !== undefined ? reasons.processed : true,
        processDate: reasons.processDate || new Date().getTime(),
        processedBy: reasons.processedBy || '',
        comments: reasons.comments || ''
      };
      set(editSosRef(reasons.id), updateData);
    }
  }